export default __webpack_public_path__ + "static/media/bar-spinner.8d35b250.gif";